import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Check as CheckIcon } from '@mui/icons-material';
import { useSpreadsheetBackendSyncPhase } from '../../context/CampaignContext';

/**
 * Google Sheets–style indicator for debounced spreadsheet ↔ backend sync only (not CRM sync or other saves).
 */
const SpreadsheetSaveIndicator = () => {
  const phase = useSpreadsheetBackendSyncPhase();
  if (phase === 'idle') return null;

  const saving = phase === 'saving';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        pl: 0.5,
        userSelect: 'none'
      }}
    >
      {saving ? (
        <Typography
          component="span"
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontSize: 12,
            letterSpacing: 0.2
          }}
        >
          Saving…
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <CheckIcon sx={{ fontSize: 14 }} color="primary" />
          <Typography
            component="span"
            variant="caption"
            sx={{ color: 'text.secondary', fontSize: 12 }}
          >
            Saved
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default SpreadsheetSaveIndicator;
